import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { User } from '../_models/user';
import { environment } from 'src/environments/environment';
import { ActionLog } from '../_models/actionLog';
import { ActivityLog } from '../_models/activityLog';
import { CompanyGroup } from '../_models/companyGroup';
import { UserActivityLog } from '../_models/useractivitylog.ts';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  baseUrl = environment.apiUrl;

constructor(private http: HttpClient) { }

getUsers(): Observable<User[]> {
  return this.http.get<User[]>(this.baseUrl + 'users');
}

getUsersWithCompanies(): Observable<User[]> {
  return this.http.get<User[]>(this.baseUrl + 'users/withCompanies');
}

addUser(user: User) {
  return this.http.post(this.baseUrl + 'users/add', user);
}

addUserWithVehicles(user: User) {
  return this.http.post<void>(this.baseUrl + 'users/addWithVehicles', user);
}

getClientUsers(): Observable<User[]> {
  return this.http.get<User[]>(this.baseUrl + 'users/clients');
}

getUser(id: number): Observable<User> {
  return this.http.get<User>(this.baseUrl + 'users/' + id);
}

getSubuser(id: number): Observable<User> {
  return this.http.get<User>(this.baseUrl + 'users/subuser/' + id);
}

updateUser(user: User) {
  return this.http.put(this.baseUrl + 'users/' + user.id, user);
}

updateSubuser(subuser: User) {
  return this.http.put<void>(this.baseUrl + 'users/subuser/' + subuser.id, subuser);
}

changePassword(model: any) {
  return this.http.post(this.baseUrl + 'users/changePassword', model);
}
activateUser(id: number,currentUserId) {
  return this.http.patch(this.baseUrl + 'users/activate/', {id:id,createdBy:currentUserId});
}
removeUser(id: number,createdBy:number) {
  return this.http.delete(this.baseUrl + 'users/remove' ,{
    params: {
      userInfo: JSON.stringify({id:id,createdBy:createdBy})
    }
  });
}

removeSubuser(id: number) {
  return this.http.get(this.baseUrl + 'users/removeSubuser/' + id);
}

resetPassword(user: User) {
  return this.http.post(this.baseUrl + 'users/resetPassword', user);
}

getVehiclesForSubuser(id: number): Observable<CompanyGroup> {
  return this.http.get<CompanyGroup>(this.baseUrl + 'users/getVehiclesForSubuser/' + id);
}

getActionLogsByClientId(activityLog: ActivityLog): Observable<ActivityLog[]> {
  return this.http.post<ActivityLog[]>(this.baseUrl + 'users/actionlogs', activityLog);
}
getUserByClientId(clientId:number): Observable<User[]> {
  return this.http.get<User[]>(this.baseUrl + `users/getUserByClientId/${clientId}`);
}
getClientHistory(username:string): Observable<User[]> {
  return this.http.get<User[]>(this.baseUrl + `users/clientHistory/${username}`);
}
getClientsLogsByClientId(id:number):Observable<ActionLog[]>{
  return this.http.get<ActionLog[]>(this.baseUrl + `users/clientslogs/${id}`);
}
getUserActivityLogs(userId:number,epochKey:number):Observable<UserActivityLog[]>{
  return this.http.get<UserActivityLog[]>(this.baseUrl + `users/clientsacivitylogs/${userId}/${epochKey}`);
}


}
